import React from 'react';
import { connect } from 'react-redux';
import iconSrc from 'images/comments-error-blankstate.svg';
import { refetchCommentary } from 'actions/editor/commentary';

const ErrorBlankSlate = ({ reload, loading }) => (
  <div className="CommentaryBlankSlate">
    <div
      className="CommentaryBlankSlate-icon"
      style={{ background: `url(${iconSrc})` }}
    />
    <h3 className="CommentaryBlankSlate-heading">
      {t('lessons.editor.collaboration.error_blank_slate.heading')}
    </h3>
    <p>{t('lessons.editor.collaboration.error_blank_slate.body')}</p>
    <button
      type="button"
      className="NewButton NewButton--white NewButton--center"
      onClick={reload}
      children={t('lessons.editor.collaboration.try_again')}
    />
  </div>
);

const mapStateToProps = state => ({
  loading: state.editor.commentary.fetching,
});

const mapDispatchToProps = dispatch => ({
  reload() {
    dispatch(refetchCommentary());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBlankSlate);
